import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import NumberOutput from '../NumberOutput/index.js';
import DateOutput from '../DateOutput/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function TextOutput(props) {
  const {
    className,
    label,
    labelContainerClassName,
    valueContainerClassName,
    description,
    descriptionContainerClassName,
    hideLabelColon,
    block,
    spacing = 'comfortable'
  } = props;
  let {
    value
  } = props; // eslint-disable-next-line react/destructuring-assignment

  if (props.valueType === 'number') {
    value = /*#__PURE__*/React.createElement(NumberOutput // eslint-disable-next-line react/destructuring-assignment
    , _extends({
      value: props.value // eslint-disable-next-line react/destructuring-assignment

    }, props.valueProps)); // eslint-disable-next-line react/destructuring-assignment
  } else if (props.valueType === 'date') {
    // eslint-disable-next-line react/destructuring-assignment
    value = props.value ? /*#__PURE__*/React.createElement(DateOutput // eslint-disable-next-line react/destructuring-assignment
    , _extends({
      value: props.value // eslint-disable-next-line react/destructuring-assignment

    }, props.valueProps)) : null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.textOutput, !hideLabelColon && styles.withLabelColon, // NOTE:
    // styles.blok is supposed to be styles.block
    // but we encountered a strange behavior
    block && styles.blok, spacingToStyleMap[spacing], className)
  }, label && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.label, labelContainerClassName)
  }, label), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.value, valueContainerClassName)
  }, value), description && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.description, descriptionContainerClassName)
  }, description));
}

var TextOutput$1 = genericMemo(TextOutput);

export { TextOutput$1 as default };
//# sourceMappingURL=index.js.map
